export default __webpack_public_path__ + "static/cybersecurity-7e2b2af38699437100483ef5a241c32e.jpg";